import moment from 'moment';

import { isWeekend } from './isWeekend';

const monthMapping = {
    '01': i18next.t('getDays.return.monthMapping.january'),
    '02': i18next.t('getDays.return.monthMapping.february'),
    '03': i18next.t('getDays.return.monthMapping.march'),
    '04': i18next.t('getDays.return.monthMapping.april'),
    '05': i18next.t('getDays.return.monthMapping.may'),
    '06': i18next.t('getDays.return.monthMapping.june'),
    '07': i18next.t('getDays.return.monthMapping.july'),
    '08': i18next.t('getDays.return.monthMapping.august'),
    '09': i18next.t('getDays.return.monthMapping.september'),
    10: i18next.t('getDays.return.monthMapping.october'),
    11: i18next.t('getDays.return.monthMapping.november'),
    12: i18next.t('getDays.return.monthMapping.december'),
};

export const getDays = (currentMonth) => {
    const result = [];

    const from = moment(currentMonth, 'MM.YYYY').startOf('month');
    const to = moment().startOf('month');
    const isFuture = to.isAfter(from);
    const monthsToCurrent = to.diff(from, 'months');

    let whileFinishIndex = 10;

    if (isFuture && monthsToCurrent > 7) {
        whileFinishIndex = monthsToCurrent + 4;
    }

    let i = -1;
    while (i < whileFinishIndex) {
        const newMomentMonth = moment(currentMonth, 'MM.YYYY').add(i, 'month').format('MM.YYYY');

        const [month, year] = newMomentMonth.split('.');

        const newMonth = {
            dataDays: newMomentMonth,
            title: `${monthMapping[month]} ${year}`,
            month: Number(month),
            days: [...Array(moment(newMomentMonth, 'MM.YYYY').daysInMonth())].map((_, i) => ({
                day: i + 1,
                date: moment(`${i + 1}.${month}.${year}`, 'DD.MM.YYYY').format('DD.MM.YYYY'),
                isWeekend: isWeekend(`${i + 1}.${newMomentMonth}`),
            })),
        };
        result.push(newMonth);
        i++;
    }
    return result;
};
export const addMoreDays = (currentMonth, mode, addDays = 4) => {
    const result = [];
    let i = 1;

    while (i < addDays) {
        let newMomentMonth = moment(currentMonth, 'MM.YYYY').add(i, 'month').format('MM.YYYY');

        if (mode === 'first') {
            newMomentMonth = moment(currentMonth, 'MM.YYYY').subtract(i, 'month').format('MM.YYYY');
        }

        const [month, year] = newMomentMonth.split('.');

        const newMonth = {
            dataDays: newMomentMonth,
            title: `${monthMapping[month]} ${year}`,
            month: Number(month),
            days: [...Array(moment(newMomentMonth, 'MM.YYYY').daysInMonth())].map((_, i) => ({
                day: i + 1,
                date: moment(`${i + 1}.${month}.${year}`, 'DD.MM.YYYY').format('DD.MM.YYYY'),
                isWeekend: isWeekend(`${i + 1}.${newMomentMonth}`),
            })),
        };

        if (mode === 'last') {
            result.push(newMonth);
        } else {
            result.unshift(newMonth);
        }
        i++;
    }
    return result;
};

export const getMonths = (currentMonth) => {
    const result = [];

    let i = -1;

    const sortedMonths = Object.entries(monthMapping).sort((a, b) => Number(a[0]) - Number(b[0]));

    while (i < 4) {
        const newMomentYear = moment(currentMonth, 'MM.YYYY').add(i, 'year').format('MM.YYYY');
        const [month, year] = newMomentYear.split('.');

        const newYear = {
            title: year,
            month: sortedMonths.map(([monthsNum, title]) => ({
                title,
                date: moment(`${monthsNum}.${year}`, 'MM.YYYY').format('MM.YYYY'),
                dayInMonth: moment(`${monthsNum}.${year}`, 'MM.YYYY').daysInMonth(),
                days: [...Array(moment(`${monthsNum}.${year}`, 'MM.YYYY').daysInMonth())].map(
                    (_, i) => ({
                        date: moment(`${i + 1}.${monthsNum}.${year}`, 'DD.MM.YYYY').format(
                            'DD.MM.YYYY'
                        ),
                    })
                ),
            })),
        };
        result.push(newYear);
        i++;
    }
    return result;
};
export const addMoreMonths = (currentYear, addYears = 1) => {
    const result = [];

    let i = -1;

    const sortedMonths = Object.entries(monthMapping).sort((a, b) => Number(a[0]) - Number(b[0]));

    while (i < addYears) {
        const newMomentYear = moment(currentYear, 'YYYY').add(i, 'year').format('MM.YYYY');
        const [month, year] = newMomentYear.split('.');
        const newYear = {
            title: year,
            month: sortedMonths.map(([monthsNum, title]) => ({
                title,
                date: moment(`${monthsNum}.${year}`, 'MM.YYYY').format('MM.YYYY'),
                dayInMonth: moment(`${monthsNum}.${year}`, 'MM.YYYY').daysInMonth(),
                days: [...Array(moment(`${monthsNum}.${year}`, 'MM.YYYY').daysInMonth())].map(
                    (_, i) => ({
                        date: moment(`${i + 1}.${monthsNum}.${year}`, 'DD.MM.YYYY').format(
                            'DD.MM.YYYY'
                        ),
                    })
                ),
            })),
        };
        result.push(newYear);
        i++;
    }
    return result;
};

const getWeeksInMonth = (month, year) => {
    moment.updateLocale(moment.locale(), {
        week: {
            dow: 1,
        },
    });
    const weeks = [];
    const firstDay = moment([year, +month - 1]);
    const lastDay = moment(firstDay).endOf('month');
    const currentWeek = firstDay.clone().startOf('week');

    if (currentWeek.date() > 7) {
        currentWeek.add(7, 'days');
    }

    while (currentWeek < lastDay) {
        const week = {
            start: currentWeek.clone().toDate(),
            end: currentWeek.clone().endOf('week').toDate(),
        };
        weeks.push(week);

        currentWeek.add(1, 'week');
    }

    return weeks;
};

const getDatesInRange = (startDate, endDate) => {
    const dates = [];
    const currentDate = moment(startDate);

    while (currentDate <= moment(endDate)) {
        dates.push(currentDate.format('DD.MM.YYYY'));
        currentDate.add(1, 'days');
    }

    return dates;
};

export const getWeeks = (currentMonth) => {
    const result = [];

    let i = -2;
    while (i < 15) {
        const newMomentMonth = moment(currentMonth, 'MM.YYYY').add(i, 'month').format('MM.YYYY');

        const [month, year] = newMomentMonth.split('.');
        const weeks = getWeeksInMonth(month, year);

        const newWeek = {
            dataDays: newMomentMonth,
            title: `${monthMapping[month]} ${year}`,
            month: Number(month),
            date: newMomentMonth,
            weeks: weeks.map((week) => ({
                title: `${moment(week.start).format('DD')} - ${moment(week.end).format('DD')}`,
                days: getDatesInRange(week.start, week.end),
                date: newMomentMonth,
            })),
        };
        result.push(newWeek);
        i++;
    }
    return result;
};
export const addMoreWeeks = (currentMonth, mode = 'last', addWeeks = 4) => {
    const result = [];
    let i = -2;
    while (i < addWeeks) {
        const newMomentMonth = moment(currentMonth, 'MM.YYYY').add(i, 'month').format('MM.YYYY');

        const [month, year] = newMomentMonth.split('.');
        const weeks = getWeeksInMonth(month, year);

        const newWeek = {
            dataDays: newMomentMonth,
            title: `${monthMapping[month]} ${year}`,
            month: Number(month),
            date: newMomentMonth,
            weeks: weeks.map((week) => ({
                title: `${moment(week.start).format('DD')} - ${moment(week.end).format('DD')}`,
                days: getDatesInRange(week.start, week.end),
                date: newMomentMonth,
            })),
        };
        result.push(newWeek);
        i++;
    }
    return result;
};

export const getMoreDays = (lastDay) => {
    const today = moment().format('MM.YYYY');
    const lastDate = moment(lastDay, 'MM.YYYY');
    const todayDate = moment(today, 'MM.YYYY');
    const monthsBetween = todayDate.diff(lastDate, 'months');

    if (monthsBetween >= 0) {
        return addMoreDays(lastDay, 'last', monthsBetween + 4);
    }
    return [];
};
export const getMoreWeeks = (lastWeek) => {
    const today = moment().format('MM.YYYY');
    const lastDate = moment(lastWeek, 'MM.YYYY');
    const todayDate = moment(today, 'MM.YYYY');

    const monthsBetween = todayDate.diff(lastDate, 'months');

    if (monthsBetween >= 0) {
        return addMoreWeeks(lastWeek, 'last', monthsBetween + 4);
    }
    return [];
};
export const getMoreMonths = (lastMonth) => {
    const today = moment().format('YYYY');
    const lastDate = moment(lastMonth, 'YYYY');
    const todayDate = moment(today, 'YYYY');

    const monthsBetween = todayDate.diff(lastDate, 'years');

    if (monthsBetween >= 0) {
        return addMoreMonths(lastMonth, monthsBetween + 1);
    }
    return [];
};
